import React, { useMemo, useState } from 'react';
import { criarImovelComImagens } from '../../services/api';
import { obterTagsPorTipoImovel } from '../../constants/tagsImoveis';
import styles from './AdminCadastroImovel.module.css';

const estadoInicial = {
  doc_proprietario: '',
  nome: '',
  telefone: '',
  endereco: '',
  area_construida: '',
  area_total: '',
  descricao: '',
  tipo_imovel: '',
  tipo_operacao: '',
  valor: '',
};

const AdminCadastroImovel = () => {
  const [campos, setCampos] = useState(estadoInicial);
  const [tagsSelecionadas, setTagsSelecionadas] = useState([]);
  const [arquivos, setArquivos] = useState([]);
  const [status, setStatus] = useState({ tipo: '', mensagem: '' });
  const [enviando, setEnviando] = useState(false);

  const tagsDisponiveis = useMemo(
    () => obterTagsPorTipoImovel(campos.tipo_imovel),
    [campos.tipo_imovel]
  );

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'tipo_imovel') {
      const tagsPermitidas = obterTagsPorTipoImovel(value);
      setTagsSelecionadas((prev) => prev.filter((tag) => tagsPermitidas.includes(tag)));
    }

    setCampos((prev) => ({ ...prev, [name]: value }));
  };

  const handleAdicionarTag = (e) => {
    const novaTag = e.target.value;
    if (!novaTag) return;

    setTagsSelecionadas((prev) => (prev.includes(novaTag) ? prev : [...prev, novaTag]));
    e.target.value = '';
  };

  const handleRemoverTag = (tag) => {
    setTagsSelecionadas((prev) => prev.filter((item) => item !== tag));
  };

  const handleArquivos = (e) => {
    setArquivos(Array.from(e.target.files));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviando(true);
    setStatus({ tipo: '', mensagem: '' });

    const payload = {
      doc_proprietario: campos.doc_proprietario,
      nome: campos.nome,
      telefone: campos.telefone || null,
      endereco: campos.endereco || null,
      area_construida: campos.area_construida ? parseFloat(campos.area_construida) : null,
      area_total: campos.area_total ? parseFloat(campos.area_total) : null,
      descricao: campos.descricao || null,
      tipo_imovel: campos.tipo_imovel,
      tipo_operacao: campos.tipo_operacao,
      valor: campos.valor ? parseFloat(campos.valor) : null,
      tags: tagsSelecionadas,
    };

    try {
      await criarImovelComImagens(payload, arquivos);
      setStatus({ tipo: 'sucesso', mensagem: 'Imóvel cadastrado com sucesso!' });
      setCampos(estadoInicial);
      setTagsSelecionadas([]);
      setArquivos([]);
    } catch (err) {
      setStatus({ tipo: 'erro', mensagem: err.message || 'Erro ao cadastrar.' });
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className={`${styles.container} ui-surface`}>
      <h2>Cadastrar Imóvel</h2>

      <form className={styles.form} onSubmit={handleSubmit}>

        <label>Nome do Proprietário *</label>
        <input
          className="ui-input"
          type="text"
          name="nome"
          value={campos.nome}
          onChange={handleChange}
          required
        />

        <label>CPF / CNPJ do Proprietário *</label>
        <input
          className="ui-input"
          type="text"
          name="doc_proprietario"
          value={campos.doc_proprietario}
          onChange={handleChange}
          required
        />

        <label>Telefone</label>
        <input
          className="ui-input"
          type="tel"
          name="telefone"
          value={campos.telefone}
          onChange={handleChange}
        />

        <label>Endereço</label>
        <input
          className="ui-input"
          type="text"
          name="endereco"
          value={campos.endereco}
          onChange={handleChange}
        />

        <label>Tipo de Imóvel *</label>
        <select className="ui-input" name="tipo_imovel" value={campos.tipo_imovel} onChange={handleChange} required>
          <option value="">Selecione</option>
          <option value="casa">Casa</option>
          <option value="apartamento">Apartamento</option>
          <option value="terreno">Terreno</option>
          <option value="comercial">Comercial</option>
          <option value="industrial">Industrial</option>
          <option value="rural">Rural</option>
        </select>

        <label>Tipo de Operação *</label>
        <select className="ui-input" name="tipo_operacao" value={campos.tipo_operacao} onChange={handleChange} required>
          <option value="">Selecione</option>
          <option value="venda">Venda</option>
          <option value="locacao">Locação</option>
        </select>

        <label>Valor (R$)</label>
        <input
          className="ui-input"
          type="number"
          name="valor"
          value={campos.valor}
          onChange={handleChange}
          min="0"
          step="0.01"
        />

        <label>Área Construída (m²)</label>
        <input
          className="ui-input"
          type="number"
          name="area_construida"
          value={campos.area_construida}
          onChange={handleChange}
          min="0"
          step="0.01"
        />

        <label>Área Total (m²)</label>
        <input
          className="ui-input"
          type="number"
          name="area_total"
          value={campos.area_total}
          onChange={handleChange}
          min="0"
          step="0.01"
        />

        <label>Descrição</label>
        <textarea
          className="ui-input"
          name="descricao"
          rows="4"
          value={campos.descricao}
          onChange={handleChange}
        />

        <label>Tags do Imóvel</label>
        <select
          className="ui-input"
          onChange={handleAdicionarTag}
          disabled={!campos.tipo_imovel}
          defaultValue=""
        >
          <option value="">
            {campos.tipo_imovel
              ? 'Selecione uma tag para adicionar'
              : 'Escolha o tipo de imóvel para liberar as tags'}
          </option>
          {tagsDisponiveis
            .filter((tag) => !tagsSelecionadas.includes(tag))
            .map((tag) => (
              <option key={tag} value={tag}>{tag}</option>
            ))}
        </select>

        {!campos.tipo_imovel && (
          <p className={styles.tagsHelper}>As tags ficam disponíveis após escolher o tipo de imóvel.</p>
        )}

        {tagsSelecionadas.length > 0 && (
          <div className={styles.tagsSelecionadas}>
            {tagsSelecionadas.map((tag) => (
              <span key={tag} className={styles.tagItem}>
                {tag}
                <button type="button" onClick={() => handleRemoverTag(tag)} className={styles.removerTag}>
                  x
                </button>
              </span>
            ))}
          </div>
        )}

        <label>Fotos do Imóvel</label>
        <input
          className="ui-input"
          type="file"
          accept="image/*"
          multiple
          onChange={handleArquivos}
        />
        {arquivos.length > 0 && (
          <p className={styles.infoArquivos}>{arquivos.length} foto(s) selecionada(s)</p>
        )}

        {status.mensagem && (
          <p className={status.tipo === 'sucesso' ? styles.sucesso : styles.erro}>
            {status.mensagem}
          </p>
        )}

        <button className="ui-button-primary" type="submit" disabled={enviando}>
          {enviando ? 'Salvando...' : 'Cadastrar Imóvel'}
        </button>

      </form>
    </div>
  );
};

export default AdminCadastroImovel;
